export const convertFileToBase64 = async (file: File) => {
  return await new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.readAsDataURL(file);
    reader.onerror = error => reject(error);

    reader.onload = () => {
      if (reader.result) {
        resolve(reader.result);
      }
    };
  });
};
